// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__MQrhd","contact":"App_contact__13gkZ"};